import { useEffect, useRef, useState } from 'react';

const ACTIVITY_KEY = 'insightAuthLastActivity';
const TIMEOUT = 30 * 60 * 1000;
const WARNING = 25 * 60 * 1000;

// User activity (shared across tabs), never network polling, controls idle logout.
const useSessionTimeout = (logout, userId) => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300);
  const lastWrite = useRef(0);
  const logoutRef = useRef(logout);
  logoutRef.current = logout;
  const extendSession = () => {
    localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
    setShowWarning(false);
    setTimeLeft(300);
  };
  const handleLogout = () => logoutRef.current(); // Keep token until App sends server logout.

  useEffect(() => {
    if (!userId) return;
    if (!localStorage.getItem(ACTIVITY_KEY)) localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
    let ended = false;
    const check = () => {
      const idle = Date.now() - Number(localStorage.getItem(ACTIVITY_KEY) || Date.now());
      setShowWarning(idle >= WARNING);
      setTimeLeft(Math.max(0, Math.ceil((TIMEOUT - idle) / 1000)));
      if (idle >= TIMEOUT && !ended) {
        ended = true;
        logoutRef.current();
      }
    };
    const activity = () => {
      const now = Date.now();
      const idle = now - Number(localStorage.getItem(ACTIVITY_KEY) || now);
      if (idle < WARNING && now - lastWrite.current >= 1000) {
        localStorage.setItem(ACTIVITY_KEY, String(now));
        lastWrite.current = now;
      }
    };
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach((event) => document.addEventListener(event, activity, { passive: true }));
    window.addEventListener('storage', check);
    const interval = setInterval(check, 1000);
    check();
    return () => {
      clearInterval(interval);
      events.forEach((event) => document.removeEventListener(event, activity));
      window.removeEventListener('storage', check);
    };
  }, [userId]);
  return { showWarning, timeLeft, extendSession, handleLogout };
};
export default useSessionTimeout;
